// extracted by mini-css-extract-plugin
module.exports = {"success":"colors_success__2c-vJ","info":"colors_info__2Rwcu","warning":"colors_warning__2c8px","danger":"colors_danger__2Soem","error":"colors_error__3aEX8"};